import { createIcon } from '@aries/mobile-core/components/ImageIcon';

export const IconClose = createIcon(require('./close.png'));
